import _ from "lodash"
import { iconFromName } from "../../services/icon.service"

const getPlansForSelectedPhone = state => {
  // get the selected phone from the basket store
  const selectedPhoneID = state.basket.phoneID

  // Filter the loaded plans to just get the ones for the selected phone
  const plansForPhone = state.plans.allIDs
    .map(planID => ({ ...state.plans.byID[planID], id: planID }))
    .filter(plan => plan.devices[selectedPhoneID] !== undefined)

  return plansForPhone
}

// Get all the plans for the selected phone in the basket
export const getPlanData = state => {
  // get the selected phone from the basket store
  const selectedDeviceID = state.basket.phoneID

  const fullPlanData = getPlansForSelectedPhone(state).map(plan => {
    // get the costs for this
    const { devices, benefits, ...rest } = plan

    // Get the benefit details

    const benefitDetails = benefits.reduce((agg, benefitID) => {
      const benefit = state.benefits.byID[benefitID]
      if (benefit.icon) {
        benefit.iconSrc = iconFromName(benefit.icon) // get the icon src if needed
      }
      return {
        ...agg,
        [benefitID]: benefit
      }
    }, {})

    const costsWithoutVAT = _.clone(plan.devices[selectedDeviceID])
    Object.keys(costsWithoutVAT).map(
      costName =>
        (costsWithoutVAT[costName] =
          costsWithoutVAT[costName] / state.plans.options.vatDivider)
    )

    // Return the new object for the user
    return {
      ...rest,
      costs: state.plans.options.excludeVAT
        ? costsWithoutVAT
        : plan.devices[selectedDeviceID],
      benefits: benefitDetails
    }
  })

  const orderedFullPlanData = state.plans.planOrderByDevice[
    selectedDeviceID
  ].map(planID => fullPlanData.find(planData => planData.id === planID))

  // now replace the benefits with the actual benefit data

  return orderedFullPlanData
}

export const getSelectedPlanName = state => {
  const planName =
    state.plans.byID[state.basket.planID] &&
    state.plans.byID[state.basket.planID].data &&
    state.plans.byID[state.basket.planID].data.name

  let postName =
    state.plans.byID[state.basket.planID] &&
    state.plans.byID[state.basket.planID].data &&
    state.plans.byID[state.basket.planID].data.postName

  if (postName) {
    return `${planName} ${postName}`
  } else {
    return planName
  }
}

export const getPlanStyle = state => {
  return state.plans.options.planStyle || "DEFAULT"
}

export const getPlanOptionWithName = state => optionName =>
  state.plans.options[optionName]

export const getMaximumNumberOfPlansToDisplay = state => {
  return state.plans.options.numberOfPlansToDisplay || 4
}

export const getDefaultPlan = state => {
  // get the selected phone from the basket store
  const selectedDeviceID = state.basket.phoneID

  return state.plans.defaultPlanByDevice[selectedDeviceID]
}

export const isPlanBuilder = state => {
  return (
    state.plans.buildAPlanByStores &&
    !!state.plans.buildAPlanByStores[state.condition.storeName]
  )
}

export const isPlanBuildableForDevice = (deviceID, state) => {
  return (
    state.plans.buildAPlanByStores &&
    !!state.plans.buildAPlanByStores[state.condition.storeName] &&
    !!state.plans.buildAPlanByStores[state.condition.storeName].devices[
      deviceID
    ]
  )
}

export const isPlanBuildableForCurrentDevice = state => {
  return isPlanBuildableForDevice(state.basket.phoneID, state)
}

export const getPlanBuilderData = state => {
  const selectedStoreName = state.condition.storeName
  const selectedDeviceID = state.basket.phoneID

  return (
    state.plans.buildAPlanByStores &&
    state.plans.buildAPlanByStores[selectedStoreName].devices[selectedDeviceID]
  )
}

export const getPlanBuilderDataForDevice = (deviceID, state) => {
  const selectedStoreName = state.condition.storeName

  return (
    state.plans.buildAPlanByStores &&
    state.plans.buildAPlanByStores[selectedStoreName].devices[deviceID]
  )
}

export const getPlanBuilderCost = state => {
  return (upfront, duration, dataIndex) => {
    const planData = getPlanBuilderData(state)
    const { deviceCost, data, multiplier } = planData

    return (
      ((deviceCost - upfront) / duration + data[dataIndex].cost) * multiplier
    )
  }
}

export const getHasHiddenPlans = state => {
  return (
    Object.values(state.plans.byID).find(plan => plan.data.defaultHidden) !==
    undefined
  )
}

export const hasRelativePricing = state => {
  return !!state.plans.options.relativePricing
}

/**
 * Get all the prices of the plans
 * @param {State} state
 * @returns Array of the prices of the plans, in the order of allIDs
 */
export const getAllPricings = state => {
  return state.plans.allIDs.map(
    planID => Object.values(state.plans.byID[planID].devices)[0].maf
  )
}

/**
 * Get all the names of the plans
 * @param {State} state
 * @returns Array of the names of the plans, in order of allIDs
 */
export const getAllPlanNames = state => {
  return state.plans.allIDs.map(planID => {
    const planName =
      state.plans.byID[planID] &&
      state.plans.byID[planID].data &&
      state.plans.byID[planID].data.name

    let postName =
      state.plans.byID[planID] &&
      state.plans.byID[planID].data &&
      state.plans.byID[planID].data.postName

    if (postName) {
      return `${planName} ${postName}`
    } else {
      return planName
    }
  })
}
